import React from "react";
import { ComponentBackgroundColor } from "types/componentBackground";
import DateOnlyFormat from "./DateOnlyFormat";
import LinkCard from "./Card/LinkCard";
import { PartialSanityImageType } from "@silversea-ssc/ui-components-react";

interface CruiseEventCard {
  cardBackgroundColor: ComponentBackgroundColor;
  image?: PartialSanityImageType;
  title: string;
  date: Date;
  location: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CruiseEventCard: React.FC<CruiseEventCard> = ({
  image,
  title,
  date,
  location,
  cardBackgroundColor,
  onClick
}) => {
  return (
    <LinkCard
      backgroundColor={cardBackgroundColor}
      title={title}
      image={image}
      imageAltText={title}
      description={
        <>
          {date && (
            <DateOnlyFormat
              value={date}
              format={{
                year: "numeric",
                month: "long",
                day: "numeric"
              }}
            />
          )}
          <p>{location}</p>
        </>
      }
      onClick={onClick}
    />
  );
};

export default CruiseEventCard;
